/* eslint-disable */
import { Mesh } from 'three';

import * as BufferGeometryUtils from 'three/examples/jsm/utils/BufferGeometryUtils';

import EleganceDoor, { braceStyle } from './Base';

import {
  getRGBFromRAL,
  metalMat,
  mirrorGlassMat,
  pinewoodBodyMat,
  pinewoodFrameMat,
} from '../Materials';

const mediaBucketUrl = process.env.NEXT_PUBLIC_MEDIA_BUCKET_URL;

export default class NewRusticDoor extends EleganceDoor {
  constructor(...args) {
    super(...args);

    const attributes = args[0];

    // load the key resources
    this.resourceManager.loadResources(
      [
        'handleInner',
        'simpleSystem',
        'hamakSystem',
        'rollerSystem',
        'hiddenSystem',
      ],
      () => {
        this.update(attributes);
        this.renderFunc();
      }
    );

    // Define the materials
    this.materialDefinitions = {
      metal: { ...metalMat },
      mirror: { ...mirrorGlassMat },
      woodBody: { ...pinewoodBodyMat, aoMapIntensity: 2.5 },
      woodFrame: { ...pinewoodFrameMat },
    };

    this.parameters.handle = false;

    this.initMaterials();
    this.update(attributes);
  }

  updateModelParameters(attributes) {
    // Set the parameters
    const doorStyle = attributes['door-style']
      ? attributes['door-style']
      : 'vertical-1';
    const styleParams = doorStyle.split('-');
    this.parameters.style = styleParams[0];
    this.parameters.density =
      typeof styleParams[1] === 'undefined' ? 1 : +styleParams[1];
    this.parameters.system = attributes['system-style']
      ? attributes['system-style']
      : this.parameters.system;
    this.parameters.brace = braceStyle[styleParams[0]];

    // Set the new texture
    const doorColor = attributes['door-color']
      ? attributes['door-color']
      : attributes['door-color-oil']
      ? attributes['door-color-oil']
      : attributes['door-color-paint']
      ? attributes['door-color-paint']
      : 'pinewood_ral9010';

    this.parameters.color = doorColor;

    const colorParams = doorColor.split('_');
    this.parameters.color = doorColor;

    if (/ral|ncs/.test(colorParams[1])) {
      this.materialDefinitions.woodFrame.color = getRGBFromRAL(colorParams[1]);
      this.materialDefinitions.woodBody.color = getRGBFromRAL(colorParams[1]);
      this.materialDefinitions.woodFrame.map = null;
      this.materialDefinitions.woodBody.map = null;
    } else {
      this.materialDefinitions.woodFrame.color = null;
      this.materialDefinitions.woodBody.color = null;
      this.materialDefinitions.woodFrame.map = `${mediaBucketUrl}textures/${doorColor}_frame.jpg`;
      this.materialDefinitions.woodBody.map = `${mediaBucketUrl}textures/${doorColor}_body.jpg`;
    }

    this.updateMaterial(
      this.materials.woodFrame,
      this.materialDefinitions.woodFrame
    );
    this.updateMaterial(
      this.materials.woodBody,
      this.materialDefinitions.woodBody
    );
  }

  buildModel() {
    const Frame = this.buildFrameGeometry();
    const Body = this.buildBodyGeometry();
    const Brace = this.parameters.brace ? this.buildBraceGeometry() : null;
    const Mirror =
      this.parameters.style === 'mirror' ? this.buildMirrorGeometry() : null;
    //const Handle = this.buildHandleGeometry();
    const Hanger = this.buildHangerGeometry();

    if (Frame) {
      this.group.add(
        new Mesh(
          BufferGeometryUtils.mergeGeometries(Frame),
          this.materials.woodFrame
        )
      );
    }
    if (Body) {
      this.group.add(
        new Mesh(
          BufferGeometryUtils.mergeGeometries(Body),
          this.materials.woodBody
        )
      );
    }
    if (Brace) {
      this.group.add(
        new Mesh(
          BufferGeometryUtils.mergeGeometries(Brace),
          this.materials.woodFrame
        )
      );
    }
    if (Mirror) {
      this.group.add(
        new Mesh(
          BufferGeometryUtils.mergeGeometries(Mirror),
          this.materials.mirror
        )
      );
    }
    //Handle.forEach((geometry) => {
    // this.group.add(new Mesh(geometry, this.materials.metal));
    //});
    Hanger.forEach((geometry) => {
      this.group.add(new Mesh(geometry, this.materials.metal));
    });

    this.group.children.forEach((z) => {
      z.castShadow = true;
      z.receiveShadow = true;
    });

    this.group.position.y = -38;
  }
}
